module.exports = __webpack_public_path__ + "media/slot-game/bread-a64ed421.svg";